iScreenWizard.factory('Test', function ($q, Ajax) {

    var data = {};

    data.all = function(params) {
        if (typeof params === 'undefined') {
            params = {};
        }
        return $q(function (resolve, reject) {
            Ajax.get('test', params).then(function (response) {
                var tests = response.data;
                resolve(tests);
            }, reject);
        });
    };

    data.get = function(id) {
        return $q(function (resolve, reject) {
            Ajax.get('test/'+id).then(function (response) {
                var test = response.data;
                resolve(test);
            }, reject);
        });
    };

    return data;
});